module.exports = __webpack_public_path__ + "img/bluegrey.28330025.jpg";